import React from 'react';
import styles from './listEditBar.module.scss';
import {
  Nav,
  NavDropdown,
  NavItem,
  NavLink,
  NavDropdownProps
} from 'react-bootstrap';
import Tags from 'components/common/Tags/Tags';
import i18n from 'i18n';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const SubDropdown: React.FC<React.PropsWithChildren<NavDropdownProps>> = ({
  children,
  ...props
}) => {
  return (
    <NavDropdown {...props} className={cx(styles.subDropdown, props.className)}>
      {children}
    </NavDropdown>
  );
};

export const ListEditBar: React.FC<
  React.PropsWithChildren<{
    selectedItems: (string | number)[];
    handleRemoveSelect?: () => void;
  }>
> & {
  Item: typeof NavItem;
  Link: typeof NavLink;
  Dropdown: typeof NavDropdown;
  SubDropdown: typeof SubDropdown;
} = ({ selectedItems, handleRemoveSelect, children }) => {
  const selectedCount = selectedItems.length;
  const tagsValue = [
    `${i18n.t('campaignList.labels.selected')}  ${selectedCount}`
  ];

  return (
    <div className={styles.container}>
      <Nav variant='pills' className={styles.listEditBar}>
        {handleRemoveSelect && (
          <Tags value={tagsValue} disableInput onChange={handleRemoveSelect} />
        )}
        {children}
      </Nav>
    </div>
  );
};

ListEditBar.Item = Nav.Item;
ListEditBar.Link = Nav.Link;
ListEditBar.Dropdown = NavDropdown;
ListEditBar.SubDropdown = SubDropdown;
